import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, ShoppingBag, ArrowUpRight } from 'lucide-react';
import { useCart } from '../context/CartContext';

export default function Header() {
  const [open, setOpen] = useState(false);
  const { cart } = useCart();
  const count = (cart?.items || []).reduce((sum, item) => sum + item.quantity, 0);
  return <>
    <div className="announcement">DELER OG DETALJER FOR DIN BMW <span>•</span> SENDES FRA NORGE</div>
    <header className="site-header">
      <div className="site-header-inner">
        <Link className="wordmark" to="/" onClick={() => setOpen(false)} aria-label="BMW Plug, hjem">
          <span className="wordmark-symbol">B<span>.</span></span><span>BMW<span className="wordmark-light">PLUG</span><small>.NO</small></span>
        </Link>
        <nav className={`site-nav ${open ? 'is-open' : ''}`} aria-label="Hovedmeny">
          <NavLink to="/" end onClick={() => setOpen(false)}>Butikk</NavLink>
          <NavLink to="/about" onClick={() => setOpen(false)}>Om oss</NavLink>
          <a href="mailto:support@bmwplug.no" onClick={() => setOpen(false)}>Kontakt <ArrowUpRight size={15}/></a>
        </nav>
        <div className="header-actions">
          <Link className="cart-link" to="/cart" aria-label={`Handlekurv, ${count} varer`}><ShoppingBag size={21}/><span>Handlekurv</span><b>{count}</b></Link>
          <button className="menu-toggle" onClick={() => setOpen(!open)} aria-label={open ? 'Lukk meny' : 'Åpne meny'}>{open ? <X/> : <Menu/>}</button>
        </div>
      </div>
    </header>
  </>;
}
